import { useQuery } from '@tanstack/react-query';
import api from '~/api';

export function useMerchantPaidProtectUnits() {
  return useQuery({
    queryKey: ['merchant-paid-protection-options'],
    queryFn: () => api.merchantPaidProtectSet(),
    select: (data) => data.sort((a, b) => a.chargeAmount - b.chargeAmount),
  });
}
